import { useState } from 'react'

import { Box, Form, Section } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import AccessGroup from 'modules/core/store/models/AccessGroup'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import DynamicNewReviewee from 'modules/reviews/components/Participants/DynamicNewReviewee'
import ManualNewReviewee from 'modules/reviews/components/Participants/ManualSelection'
import type { Reviewees } from 'modules/reviews/lib/types'
import type Review from 'modules/reviews/store/models/v2/Review'

import GroupForm from './GroupForm'
import Table from './Table'

interface HeaderProps {
  accessGroup: AccessGroup
  form: Review
  onSubmit: () => void
  reviewees: Reviewees
  canEditReview: boolean
  contractVersions: ContractVersions
}

export function ReviewParticipantsContent({
  accessGroup,
  onSubmit,
  form,
  reviewees,
  canEditReview,
  contractVersions,
}: HeaderProps) {
  const [showNewParticipantModal, setNewShowParticipantModal] = useState(false)
  const isMembersStrategy = accessGroup.attributes.strategy === AccessGroup.Strategies.members

  // add participants only when dynamic and active or manual and draft or active
  const isDynamicAndDraft = !isMembersStrategy && form.isDraft
  const canAddParticipants = canEditReview && !isDynamicAndDraft && !form.isFinished

  const onCloseNewParticipantModal = () => {
    setNewShowParticipantModal(false)
  }

  return (
    <Box>
      <Section
        illustration="surveys"
        title={i18n.t('surveys.form.participants.title')}
        description={i18n.t('surveys.form.participants.description')}
        action={
          canAddParticipants
            ? {
                onClick: () => setNewShowParticipantModal(true),
                label: i18n.t('surveys.form.participants.new.title'),
              }
            : undefined
        }
      >
        {!isMembersStrategy && (
          <Form withBackground>
            <GroupForm
              accessGroup={accessGroup}
              onSubmit={onSubmit}
              reviewForm={form}
              canEditReview={canEditReview}
            />
          </Form>
        )}
      </Section>
      <Box paddingX="s64">
        <Table form={form} reviewees={reviewees} />
      </Box>

      {showNewParticipantModal && isMembersStrategy && (
        <ManualNewReviewee
          accessGroup={accessGroup}
          reviewId={form.attributes.id}
          reviewStatus={form.attributes.status}
          onClose={onCloseNewParticipantModal}
          contractVersions={contractVersions}
        />
      )}

      {showNewParticipantModal && !isMembersStrategy && (
        <DynamicNewReviewee
          reviewId={form.attributes.id}
          onClose={onCloseNewParticipantModal}
          contractVersions={contractVersions}
        />
      )}
    </Box>
  )
}
